import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ApiService } from '../../services/api.service';
import { GuardsService } from '../../services/guards.service';
import { UserService } from '../../services/user.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent {

  loginForm: FormGroup|null = null;
  loginLoading = false;

  constructor(
    private apiService: ApiService,
    private userService: UserService,
    private router: Router,
    private guardsService: GuardsService
  ) {
    this.initLoginForm();
  }

  initLoginForm(): void {
    this.loginForm = new FormGroup({
      username: new FormControl('', [Validators.required]),
      password: new FormControl('', [Validators.required]),
      stayLoggedIn: new FormControl(false)
    });
  }

  login(): void {
    if (this.loginForm === null) {
      return;
    }
    this.loginForm.disable();
    this.loginLoading = true;
    this.apiService.login(this.loginForm.value).subscribe((rsp) => {
      this.userService.userData = rsp.userData;
      this.router.navigate(this.guardsService.navigateAfterLoginCommands);
    }).add(() => {
      this.loginLoading = false;
      this.loginForm.enable();
    });
  }

}
